import { updater } from "../../utils/updater.js";

/**
 * Mailview API factory.
 *
 */
export function mailViewFactory({ state, setState }) {
  // shorthand for setState(produce(draft => {...}))
  const updateState = updater(setState);

  const setFilesSelection = (selection) =>
    updateState((draft) => {
      draft.fileSelection = selection;
    });

  const toggleFileSelect = (itemId) => {
    const stringId = "" + itemId;
    updateState((draft) => {
      draft.fileSelection = draft.fileSelection.includes(stringId)
        ? [...draft.fileSelection].filter((id) => id !== stringId)
        : [...draft.fileSelection, stringId];
    });
  };

  const getFilesSelection = () => state.fileSelection;
  const getFileSelected = (itemId) => getFilesSelection().includes("" + itemId);

  const setRemoveModeItemId = (itemId) => {
    updateState((draft) => {
      draft.removeModeItemId = itemId;
    });
  };
  const getRemoveModeItemId = () => state.removeModeItemId;

  const setShiftModeSelectedItemId = (itemId) => {
    updateState((draft) => {
      draft.shiftModeItemId = itemId;
    });
  };
  const getShiftModeSelectedItemId = () => state.shiftModeItemId;

  const getGridView = () => state.gridView;
  const setGridView = (bool) =>
    updateState((draft) => {
      draft.gridView = bool;
    });

  const getMobileGridView = () => state.mobileGridView;
  const setMobileGridView = (bool) =>
    updateState((draft) => {
      draft.mobileGridView = bool;
    });

  const getAudioPlaySrc = () => state.audioPlay;
  const setAudioPlaySrc = (src) =>
    updateState((draft) => {
      draft.audioPlay = src;
    });

  return {
    getFileSelected,
    getGridView,
    setGridView,
    getMobileGridView,
    setMobileGridView,
    getFilesSelection,
    setFilesSelection,
    setRemoveModeItemId,
    getRemoveModeItemId,
    setShiftModeSelectedItemId,
    getShiftModeSelectedItemId,
    toggleFileSelect,
    getAudioPlaySrc,
    setAudioPlaySrc,
  };
}

export default mailViewFactory;
